import { useEffect, useRef } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import type Player from 'video.js/dist/types/player'

interface VideoPlayerProps {
  srcObj: { src: string; type: string }
  controls?: boolean
  autoplay?: boolean
  loop?: boolean
  width?: string | number
  height?: string | number
  poster?: string
  play?: boolean
  onReady?: (player: Player) => void
}

const VideoPlayer = (props: VideoPlayerProps) => {
  const videoRef = useRef<any>(null)
  const playerRef = useRef<any>(null)

  //destructure props for easier access
  const { srcObj, controls, autoplay, width, height, loop, poster, play, onReady } = props

  useEffect(() => {
    const options = {
      controls: controls || false,
      autoplay: autoplay,
      muted: true,
      preload: true,
      width: width || '100%',
      height: height || '100%',
      bigPlayButton: true,
      loop: loop,
      errorDisplay: false,
      sources: [srcObj],
    }

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      //const onReady = props.onReady

      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('video-js')
      videoElement.classList.add('vjs-16-9')
      videoRef.current.appendChild(videoElement)

      const player = (playerRef.current = videojs(videoElement, options, () => {
        if (poster) {
          player.poster(poster)
        }
        onReady && onReady(player)
        if (play) {
          //player.play()
        } else {
          //player.pause()
        }
      }))
    } else {
      const player = playerRef.current
      player.autoplay(options.autoplay)
      player.src(srcObj)
    }
  }, [srcObj, controls, autoplay, width, height, loop, poster, play, onReady, videoRef])

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    // <div data-vjs-player>
    //   <video ref={playerRef} className="video-js vjs-16-9" playsInline />
    // </div>
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  )
}

export default VideoPlayer
